
import { Team } from "@/types"
import { Component, Vue, Watch, Prop } from "vue-property-decorator"

import cloneDeep from "lodash/cloneDeep"
import vSelect from "vue-select"

@Component({
	components: {
		"v-select": vSelect
	}
})
export default class UserRoleTeams extends Vue {
	@Prop()
	value!: { [role: string]: string | null } | null

	@Prop({ default: () => [] })
	teams!: Team[]

	renamedRoles: { [oldValue: string]: string } = {}

	get roleMapping (): { role: string, team: string | null }[] {
		if (!this.value) return []

		return Object.keys(this.value).map(role => {
			return {
				role,
				team: this.value![role]
			}
		})
	}

	changeRoleName (oldName: string, newName: string) {
		this.renamedRoles[oldName] = newName
	}

	updateName (oldName: string) {
		const value = cloneDeep(this.value)
		const newName = this.renamedRoles[oldName]

		if (value) {
			let team: string | null = null
			if (value[oldName]) {
				team = value[oldName]
			}
			Vue.delete(value, oldName)
			Vue.set(value, newName, team)
		}

		delete this.renamedRoles[oldName]

		this.$emit("input", value)
	}

	addRole () {
		const value = cloneDeep(this.value) || {}
		value[""] = null

		this.$emit("input", value)
	}

	setTeams (role: string, team: string) {
		const value = cloneDeep(this.value) || {}
		value[role] = team
		this.$emit("input", value)
	}
}

